module.exports = __webpack_public_path__ + "static/3.1fa68734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Masthead/3.svg
// module id = 432
// module chunks = 35783957827783